<template>
  <div>
    <div v-if="landing_page_component.value === 'Map'">
      <Map :is_landing_page="true" :default_map_id="Number(landing_page_map_id.value)"></Map>
    </div>
    <div v-else-if="landing_page_component.value === 'Calendar'">
      <Calendar></Calendar>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Calendar from '../../components/Scheduler/Calendar/Calendar'
import Map from '../../components/Map/Map'

export default {
  components: { Calendar, Map },
  computed: {
    ...mapGetters({
      phoenix_settings: 'allPhoenixSettings',
      scoped_site_id: 'scopedSiteId'
    }),
    landing_page_component: function () {
      return this.phoenix_settings.find(ps => ps.site_id === this.scoped_site_id && ps.setting === 'COMPONENT') || 'Calendar'
    },
    landing_page_map_id: function () {
      return this.phoenix_settings.find(ps => ps.site_id === this.scoped_site_id && ps.setting === 'MAP_ID')
    }
  },
  created () {
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.LANDING_PAGE')
  }
}
</script>
